import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormDirectivesService } from '../../../../../shared/directives/dynamic-form-directive/form-directives.service';

@Component({
  selector: 'app-contact-info-edited-notice-modal',
  imports: [],
  templateUrl: './contact-info-edited-notice-modal.component.html',
})
export class ContactInfoEditedNoticeModalComponent {
  readonly ngbActiveModal = inject(NgbActiveModal);
  readonly maskService = inject(FormDirectivesService);

  @Input() newEmail: string = '';
  @Input() existingEmail: string = '';
  @Input() phone: string = '';

  public onDismiss(): void {
    this.ngbActiveModal.dismiss();
  }
}
